import { useEffect } from "react";
import BannerHero from "../components/home/BannerHero";
import FeaturedProducts from "../components/home/FeaturedProducts";
import Standards from "../components/home/Standards";
import Reviews from "../components/home/Reviews";

export default function Home() {

  useEffect(() => {
    document.title = "Home | HD Labs";
  }, []);

  return (
    <>
      <BannerHero />
      <FeaturedProducts />

      {/* Section for footer navigation */}
      <div id="standards">
        <Standards />
      </div>

      <div id="reviews">
        <Reviews />
      </div>
    </>
  );
}